import { GET, POST } from "./api.js";

export const errors = {
    administrationErrorsDetection: ( data) => POST(`/errors`, data),
    addErroLog:(data)=>POST('/add-logs', data)
}